import React from 'react';

// The paintings the landing page is built around, with the placard each one
// carries: who, what, when, and one line on why it is here.
export const PAINTINGS = {
  delacroix: {
    artist: 'After Eugène Delacroix',
    title: 'The Barque of Dante',
    date: '1822',
    medium: 'Oil on canvas',
    note: 'Virgil steadies Dante as they cross the Styx. Every hard draft has a crossing like this one.',
  },
  parnassus: {
    artist: 'Raphael',
    title: 'The Parnassus',
    date: '1509–1511',
    medium: 'Fresco',
    note: 'Homer, Virgil, Dante, and Sappho share the mountain with Apollo and the Muses. Poets have always worked in company.',
  },
  philosopher: {
    artist: 'Rembrandt',
    title: 'Philosopher in Meditation',
    date: '1632',
    medium: 'Oil on panel',
    note: 'A window of light, a winding stair, and a mind at work. Rembrandt painted the act of thinking.',
  },
  virgilTomb: {
    artist: 'Joseph Wright of Derby',
    title: "Virgil's Tomb by Moonlight",
    date: '1779',
    medium: 'Oil on canvas',
    note: "The Roman poet Silius Italicus kept Virgil's tomb as a shrine. Writers have always gone looking for a guide.",
  },
};

// A museum label set beside a painting.
export function Placard({ painting, className = '' }) {
  return (
    <div className={`placard ${className}`.trim()}>
      <span className="placard-artist">{painting.artist}</span>
      <span className="placard-title">
        <em>{painting.title}</em>, {painting.date}
      </span>
      <span className="placard-medium">{painting.medium}</span>
      <span className="placard-note">{painting.note}</span>
    </div>
  );
}

// A painting set into the top of a section, with one line of copy over it
// and its placard beneath.
export function PaintedHeader({ art, painting, eyebrow, quote, className = '' }) {
  return (
    <figure className={`painted-header ${className}`.trim()}>
      <div className="painted-header-frame">
        <img src={art} alt="" className="painted-header-art" loading="lazy" decoding="async" />
        <span className="painted-header-veil" aria-hidden="true" />
        <div className="painted-header-copy">
          <span className="painted-header-eyebrow">{eyebrow}</span>
          <p className="painted-header-quote">{quote}</p>
        </div>
      </div>
      <figcaption>
        <Placard painting={painting} className="painted-header-placard" />
      </figcaption>
    </figure>
  );
}

// The landing page reads as a descent and a climb, one canto per section.
export function CantoMark({ numeral }) {
  return (
    <span className="canto-mark" aria-hidden="true">
      Canto {numeral}
    </span>
  );
}
